import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            username: '',
            trainings: [],
            partners: [],
            selectedPartners: [],
            slots: [],
            slotsPerDay: [],
            slotFilter: '-1',
            usersCanReserveTrainingWithScanQr: false,
            fromDate : null,
            toDate: null,
            filter: '',
            totalPrice: 0,
            totalTrainings: 0,
            partnerCompanies: [],
            totalSlots: 0,
            weeklyReport: false,
            pagination: {
                page: 1,
                limit: 50,
                totalCount: 0
            },
            useProfilePictures: false,
            showVegaReport: false,
            showTotalPrice: false,
            showUserTrainingTypeOnTraining: false,
            shouldApproveReservedTraining: false,
            showAddKeyForTraining: false,
            showTrainingType: CONFIG_COMPANY.SHOW_TRAINING_TYPE_REPORT,
            showImagePreview: false,
            imageToPreviewUserId: 0,
            imageToPreview: "",
            loadingWeeklyReport: false,
            weaklyReportLoaded: false,
            reservationSummaryLoading: false,
            reservationSummary: {
                totalReservations: 0,
                mostPopularTerm: null,
                alwaysFullTerms: [],
                termStats: []
            }
        }
    },
    methods: {
        load: load,
        calculatePrice: calculatePrice,
        clickSearch: clickSearch,
        generateExcelFile: generateExcelFile,
        approveTraining: approveTraining,
        getPartners: getPartners,
        clickSelectPartner: clickSelectPartner,
        isSelected: isSelected,
        getChipClass: getChipClass,
        getDisplayNameFromDay: getDisplayNameFromDay,
        loadPaymentByCompany: loadPaymentByCompany,
        loadPaymentByPartnerCompany: loadPaymentByPartnerCompany,
        openImage: openImage,
        formatDate: formatDate,
        loadCompanyPartner: loadCompanyPartner,
        showWeeklyReport: showWeeklyReport,
        generateReportHtml: generateReportHtml,
        keymonitor: keymonitor,
        loadReservationSummary: loadReservationSummary,
        chartWidth: chartWidth,
        chartLabel: chartLabel,
        formatPercent: formatPercent

    },

    computed: {
        filteredSlots(){
            return this.slotsPerDay;
        },
        popularTermLabel() {
            if (!this.reservationSummary.mostPopularTerm) return this.locale.t('label_no_data_for_period');
            return this.chartLabel(this.reservationSummary.mostPopularTerm);
        },
        popularTermReservations() {
            if (!this.reservationSummary.mostPopularTerm) return this.locale.t('label_no_data_for_period');
            return Number(this.reservationSummary.mostPopularTerm.totalReservations || 0);
        },
        popularTermsChart() {
            const stats = (this.reservationSummary.termStats || []).slice();
            return stats
                .sort((a, b) => Number(b.totalReservations || 0) - Number(a.totalReservations || 0))
                .slice(0, 8);
        },
        occupancyTermsChart() {
            const stats = (this.reservationSummary.termStats || []).slice();
            return stats
                .sort((a, b) => Number(b.fullSlotsPercent || 0) - Number(a.fullSlotsPercent || 0))
                .slice(0, 8);
        },
        alwaysFullChart() {
            const stats = (this.reservationSummary.alwaysFullTerms || []).slice();
            return stats
                .sort((a, b) => Number(b.totalReservations || 0) - Number(a.totalReservations || 0))
                .slice(0, 8);
        },
        maxPopularReservations() {
            if (!this.popularTermsChart.length) return 0;
            return Math.max(...this.popularTermsChart.map(i => Number(i.totalReservations || 0)));
        },
        maxAlwaysFullReservations() {
            if (!this.alwaysFullChart.length) return 0;
            return Math.max(...this.alwaysFullChart.map(i => Number(i.totalReservations || 0)));
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.username = session.getUsername();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.showVegaReport = session.getConfig().enableVegaReport == null ? true : session.getConfig().enableVegaReport
        this.showTotalPrice = CONFIG_COMPANY.SHOW_TOTAL_PRICE_REPORT;
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.usersCanReserveTrainingWithScanQr = session.getConfig().usersCanReserveTrainingWithScanQr != null && session.getConfig().usersCanReserveTrainingWithScanQr !== ""
        this.shouldApproveReservedTraining = session.getConfig().shouldApproveReservedTraining == null ? false : session.getConfig().shouldApproveReservedTraining
        this.showUserTrainingTypeOnTraining = CONFIG_COMPANY.SHOW_USER_TRAINING_TYPE_ON_TRAINING;
        this.showAddKeyForTraining = CONFIG_COMPANY.ADD_KEY_FOR_TRAINING;
        this.load()
        this.calculatePrice();
        this.getPartners();
        this.loadCompanyPartner();
        this.loadReservationSummary();
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
                this.calculatePrice();
            }
        },
        'slotFilter': function (newVal){
            this.pagination.page = 1;
            this.load()
            this.calculatePrice();
        },
        'fromDate': function (newVal){
            this.weaklyReportLoaded = false;
            this.weeklyReport = false;
        },
        'toDate': function (newVal){
            this.weaklyReportLoaded = false;
            this.weeklyReport = false;
        }
    }
}

function showWeeklyReport(){
    let _self = this;
    this.weeklyReport = !this.weeklyReport
    if(_self.weaklyReportLoaded) return;
    this.loadingWeeklyReport = true;
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        slotFilter: _self.slotFilter,
    }

    AdminApiService.getSlotReport(model)
        .then((response) => {
            _self.loadingWeeklyReport = false
            _self.weaklyReportLoaded = true
            _self.slots = response.data;
            _self.generateReportHtml(LocService.t('label_weekly_report_title'), _self.slots, true);
        })
        .catch(error => {
            _self.loadingWeeklyReport = false
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
    this.calculatePrice();
    this.loadReservationSummary();
}

function calculatePrice(){
    if(this.showTotalPrice === false) return;
    let paymentCompany = this.selectedPartners.length === 0 ? null : this.selectedPartners[0];
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        paymentCompany: paymentCompany,
        filter: _self.filter,
    }

    AdminApiService.getCalculatePriceForReport(model)
        .then((response) => {
            _self.totalPrice = response.data.totalPrice;
            _self.totalSlots = response.data.slotCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadPaymentByCompany() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        paymentCompany: "Vega IT doo",
        filter: _self.filter,
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.getTrainingsReportByPaymentCompany(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success');
           _self.generateExcelFile(response.data, model)
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadPaymentByPartnerCompany(partnerCompany) {
    console.log(partnerCompany)
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        partnerCompany: partnerCompany,
        filter: _self.filter,
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.getTrainingsReportByPartnerCompany(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success');
            _self.generateExcelFile(response.data, model)
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function load() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        slotFilter: _self.slotFilter,
    }
    let paymentCompany = _self.selectedPartners.length === 0 ? null : _self.selectedPartners[0];
    AdminApiService.getTrainingsReport(model, paymentCompany)
        .then((response) => {
            _self.trainings = response.data.results;
            _self.totalTrainings = response.data.totalCount;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

    // AdminApiService.getSlotReport(model)
    //     .then((response) => {
    //         _self.slots = response.data;
    //     })
    //     .catch(error => {
    //         swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
    //     })

    AdminApiService.getSlotByDate(model.fromDate)
        .then((response) => {
            _self.slotsPerDay = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

    // AdminApiService.getSlotReportCount(model)
    //     .then((response) => {
    //         if(response.data.length > 0){
    //             _self.totalSlots = response.data[0].total;
    //         }
    //     })
    //     .catch(error => {
    //         swal('Greška', error.data.localized_error_message, 'error')
    //     })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.pagination.page = 1;
        this.load();
        this.calculatePrice();
        this.loadReservationSummary();
    }
}

function loadReservationSummary() {
    let _self = this;
    _self.reservationSummaryLoading = true;
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY'),
    };
    AdminApiService.getTrainingReservationSummary(model)
        .then((response) => {
            const data = response.data || {};
            _self.reservationSummary = {
                totalReservations: Number(data.totalReservations || 0),
                mostPopularTerm: data.mostPopularTerm || null,
                alwaysFullTerms: data.alwaysFullTerms || [],
                termStats: data.termStats || [],
            };
            _self.reservationSummaryLoading = false;
        })
        .catch((error) => {
            _self.reservationSummaryLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        });
}

function chartWidth(value, max) {
    const v = Number(value) || 0;
    const m = Number(max) || 0;
    if (m <= 0) return '0%';
    const ratio = (v / m) * 100;
    return `${Math.max(8, Math.min(100, ratio)).toFixed(2)}%`;
}

function chartLabel(item) {
    if (item == null) return '';
    const startAt = item.startAt || '';
    const trainingType = item.trainingType || '';
    return `${startAt} ${trainingType}`.trim();
}

function formatPercent(value) {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return 0;
    return Math.max(0, Math.min(100, Math.trunc(numberValue)));
}

function generateExcelFile(list, model){
    let _self = this;
    var dates = list[0]
    var firstRow = [];
    var secondRow = [];
    var csvFile = "";
    for(var x = 0; x < dates.length; x++){
        if(dates[x] === "*"){
            firstRow.push("*")
            secondRow.push("*")
        }else{
            var parts = dates[x].split('-');
            var newDate = new Date(parts[2], parts[1] - 1, parts[0])
            var day = this.getDisplayNameFromDay(newDate.getDay())
            firstRow.push(day)
            secondRow.push(newDate.getDate())
        }
    }
    //DODAVANJE DATUMA
    for(var f = 0; f < firstRow.length; f++){
        csvFile = csvFile + firstRow[f] + ", "
    }
    csvFile = csvFile + "\n"
    for(var s = 0; s < secondRow.length; s++){
        csvFile = csvFile + secondRow[s] + ", "
    }
    csvFile = csvFile + "\n"

    //DODAVANJE SADRZAJA, preskacemo prvi red jer smo ga iznad isarsirali
    for(var i = 1; i < list.length; i++){
        var row = list[i]
        for(var j = 0; j < row.length; j++){
            csvFile = csvFile + row[j] + ", "
        }
        csvFile = csvFile + "\n"
    }
    var fileName = model.fromDate + " " + model.toDate + "-izvestaj.csv"
    var universalBOM = "\uFEFF";
    var link = document.createElement("a");
    link.setAttribute("href", 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvFile));
    link.setAttribute("download", fileName);
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file nam
}

function getDisplayNameFromDay(day){
    switch (day) {
        case 1: return "P";
        case 2: return "U";
        case 3: return "S";
        case 4: return "Č";
        case 5: return "P";
        case 6: return "S";
        case 0: return "N";
        default: return "N";
    }
}

function getPartners(){
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data.map(e=> e.name);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getChipClass(item){
    if(this.selectedPartners.includes(item)){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedPartners.includes(item)
}

function clickSelectPartner(item){
    if(this.selectedPartners.includes(item)){
        this.selectedPartners = [];
    }else{
        this.selectedPartners = [];
        this.selectedPartners.push(item)
    }
    // if(this.selectedPartners.includes(item)){
    //     this.selectedPartners = this.selectedPartners.filter(e => e !== item)
    // }else{
    //     this.selectedPartners.push(item)
    // }
}

function formatDate(date){
    return this.$moment(date).format('DD-MM-YYYY');
}

function approveTraining(training, value){
    let _self = this;
    swal({
        title: LocService.t("label_are_you_sure"),
        text:  LocService.t("label_approve_are_you_sure") + " ( " + training.firstName + " - " + training.lastName + " )",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            trainingId: training.id,
            checked: value,
        }
        AdminApiService.approveTraining(model)
            .then((response) => {
                _self.load();
                swal(LocService.t("label_success"), LocService.t("label_success_approved_training"), 'success')
            })
            .catch(error => {
                // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    })
}

function generateReportHtml(title, slots, showTrainingType) {
    let htmlContent = `
    <html>
    <head>
        <title>${title}</title>
        <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h2 { margin-top: 30px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 30px; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
        </style>
    </head>
    <body>
        <h1>${title}</h1>
    `;

    slots.forEach(item => {
        htmlContent += `
        <h2>${item.date}</h2>
        <table>
            <tr>
                <th>Vrsta treninga</th>
                <th>Vreme</th>
                <th>Broj treninga</th>
            </tr>
        `;

        item.trainings.forEach(element => {
            htmlContent += `
            <tr>
                <td>${showTrainingType ? element.trainingType : ''}</td>
                <td>${element.startAt}</td>
                <td>${element.numberOfTrainings}</td>
            </tr>
            `;
        });

        htmlContent += `</table>`;
    });

    htmlContent += `
    </body>
    </html>`;

    let newWindow = window.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
}



// WEBPACK FOOTER //
// ./src/components/TrainingReport/TrainingReport.js